import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { Link, SvgIcon, Box, Typography, Theme } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";

interface AppBarLinkProps {
  href: string;
  id: string;
  defaultText: string;
  icon: ReactJSXElement;
}
const styledButtonSX = (theme: Theme) => ({
  "& .MuiSvgIcon-root": {
    fontSize: "25px",
  },
  "&:hover": {
    "&>*": {
      color: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
});

export const AppBarLink: React.FC<AppBarLinkProps> = ({
  href,
  id,
  defaultText,
  icon,
}) => {
  return (
    <Link href={href} sx={{ textDecoration: "none" }} marginRight="6px">
      <Box
        display="flex"
        minWidth="min-width"
        alignItems="center"
        sx={styledButtonSX}>
        <SvgIcon color="secondary">{icon}</SvgIcon>
        <Typography color="secondary" marginLeft="8px" marginBottom="2px">
          <FormattedMessage id={id} defaultMessage={defaultText} />
        </Typography>
      </Box>
    </Link>
  );
};
